import { createSlice } from '@reduxjs/toolkit';
import { SignUpStoreEntity } from '@/types/redux';

const initialState: SignUpStoreEntity = {
  email: undefined,
  password: undefined,
  firstName: undefined,
  lastName: undefined,
  referralCode: undefined,
  isTeacher: undefined,
  icode: undefined,
  inviteCode: undefined,
  inviteUserType: undefined,
  termsAndConditionsAccepted: undefined,
  isClaim: undefined,
};

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setReferralCode: (state, action) => {
      state.referralCode = action.payload;
    },
    setIsTeacher: (state, action) => {
      state.isTeacher = action.payload;
    },
    setIcode: (state, action) => {
      state.icode = action.payload;
    },
    setInviteCode: (state, action) => {
      state.inviteCode = action.payload;
    },
    setInviteUserType: (state, action) => {
      state.inviteUserType = action.payload;
    },
    setTermsAndConditionsAccepted: (state, action) => {
      state.termsAndConditionsAccepted = action.payload;
    },
    setIsClaim: (state, action) => {
      state.isClaim = action.payload;
    },
  },
});

export const {
  setEmail,
  setPassword,
  setFirstName,
  setLastName,
  setReferralCode,
  setIsTeacher,
  setIcode,
  setInviteCode,
  setInviteUserType,
  setTermsAndConditionsAccepted,
  setIsClaim,
} = signUpSlice.actions;
export default signUpSlice.reducer;
